import { useApi } from '@/api';
import { ChartTimeFilter } from '@/components';
import { Flex, DisplaySwitch } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import AssetLiquidationsGraph, { AssetData } from './AssetLiquidationsGraph';
import DatesLiquidationsGraph, { DatesData } from './DatesLiquidationsGraph';
import { useSearchParams } from '@/hooks';

export default function HistoricTabs() {
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const [activeDisplayOption, setActiveDisplayOption] = useSearchParams(
    'tab',
    'date'
  );
  const displayOptions = useMemo(
    () => [
      { key: 'date', value: 'By Date' },
      { key: 'asset', value: 'By Asset' }
    ],
    []
  );

  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  const [data, error] = useApi<AssetData[] | DatesData>({
    url: `/liquidations/historic/`,
    queryParams: {
      days_ago: chartDaysAgo,
      type: activeDisplayOption
    }
  });

  if (error) {
    throw error;
  }

  const content =
    activeDisplayOption === 'asset' ? (
      <AssetLiquidationsGraph
        data={data as AssetData[]}
        timeFilter={timeFilter}
      />
    ) : (
      <DatesLiquidationsGraph
        data={data as DatesData}
        timeFilter={timeFilter}
        daysAgo={Number(chartDaysAgo)}
      />
    );

  return (
    <Flex flexDirection="column" gap="xs">
      <DisplaySwitch
        data={displayOptions}
        activeOption={activeDisplayOption}
        onChange={setActiveDisplayOption}
      />
      {content}
    </Flex>
  );
}
